import { z } from 'zod';

export const InspectionRequestTimeSlotScalarFieldEnumSchema = z.enum(['id','inspection_id','city_id','preferred_date','meridiem','priority']);

export default InspectionRequestTimeSlotScalarFieldEnumSchema;
